import { ArrowLeft, ExternalLink, MapPin, Phone, ScanSearch } from 'lucide-react';
import Brand from './Brand';

export default function ResultsView({ image, results, onReset, onOpen }) {
  const top = results[0];
  const resultTitle = !top
    ? 'No confident match yet'
    : top.confidence >= 0.6
      ? 'Restaurant found'
      : 'Possible restaurant match';

  return (
    <div className="results-page page-frame">
      <header className="simple-header"><Brand /><button className="text-button" onClick={onReset}><ArrowLeft size={17} /> New scan</button></header>
      <main className="results-main">
        <section className="result-context">
          <div className="captured-thumb">{image ? <img src={image} alt="Captured storefront" /> : <ScanSearch />}</div>
          <div>
            <span className="eyebrow">Recognition result</span>
            <h1>{resultTitle}</h1>
          </div>
        </section>

        {top ? (
          <>
            <article className="top-result-card">
              <div className="top-result-image">{top.coverImage ? <img src={top.coverImage} alt={top.name} /> : <ScanSearch />}</div>
              <div className="top-result-body">
                <div className="confidence-ring" style={{ '--score': `${Math.round(top.confidence * 100) * 3.6}deg` }}><span>{Math.round(top.confidence * 100)}%</span></div>
                <span className="result-label">Best match</span>
                <h2>{top.name}</h2>
                {top.nameAr && <h3 dir="rtl">{top.nameAr}</h3>}
                <div className="restaurant-meta">
                  {top.location && <span><MapPin size={16} /> {top.location}</span>}
                  {top.phone && <a href={`tel:${top.phone}`}><Phone size={16} /> {top.phone}</a>}
                </div>
                <button className="primary-button" onClick={() => onOpen(top)} disabled={!top.menuUrl}>Open menu <ExternalLink size={18} /></button>
              </div>
            </article>

            {results.length > 1 && <section className="alternatives"><div className="section-heading"><div><span className="eyebrow">Other possibilities</span><h2>Similar matches</h2></div></div><div className="alternative-grid">{results.slice(1).map((result) => <article className="alternative-card" key={result.id}><div className="alternative-image">{result.coverImage ? <img src={result.coverImage} alt={result.name} /> : <ScanSearch />}</div><div><strong>{result.name}</strong>{result.nameAr && <span dir="rtl">{result.nameAr}</span>}</div><button onClick={() => onOpen(result)} disabled={!result.menuUrl}><ExternalLink size={17} /></button></article>)}</div></section>}
          </>
        ) : (
          <section className="empty-result">
            <ScanSearch />
            <h2>Restaurant not found</h2>
            <p>Nothing in this photo confidently matches a registered restaurant. Scan a restaurant sign or try another photo.</p>
            <button className="primary-button" onClick={onReset}>Try again</button>
          </section>
        )}
      </main>
    </div>
  );
}
